import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-report',
  templateUrl: 'report.component.html',
  imports: [RouterOutlet],
})
export class ReportComponent {}
